import { createClient } from '@supabase/supabase-js'

// Project credentials from environment
const SUPABASE_URL = 'https://bekzycdbewhfnvcbmgih.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJla3p5Y2RiZXdoZm52Y2JtZ2loIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQwOTQ1NjMsImV4cCI6MjA2OTY3MDU2M30.Vx2EtmYJqn6aW8IE_sE9Z6BZ-U5KnGz7jLQ4rPlC77o'

if (SUPABASE_URL === 'https://<PROJECT-ID>.supabase.co' || SUPABASE_ANON_KEY === '<ANON_KEY>') {
  console.warn('Missing Supabase credentials. Backend functionality will be limited.');
}

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});

export default supabase;